import { render, staticRenderFns } from "./notification-list.vue?vue&type=template&id=5dd20e01&scoped=true&"
import script from "./notification-list.vue?vue&type=script&lang=js&"
export * from "./notification-list.vue?vue&type=script&lang=js&"
import style0 from "../../../public/static/fonts.scss?vue&type=style&index=0&id=5dd20e01&scoped=true&lang=scss&"
import style1 from "@/assets/dot-streaching-loader.scss?vue&type=style&index=1&id=5dd20e01&scoped=true&lang=scss&"
import style2 from "./notification-list.vue?vue&type=style&index=2&id=5dd20e01&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd20e01",
  null
  
)

component.options.__file = "notification-list.vue"
export default component.exports